import { useTheme } from '../theme';
import Lighthouse from './Lighthouse';
import '../styles/ThemeToggle.css';

// Single lighthouse button: one click flips light <-> dark. The lamp lights up
// whenever the effective theme is dark. Shows "Auto" while following the system.
export default function ThemeToggle() {
  const { pref, effective, toggle } = useTheme();
  const isDark = effective === 'dark';
  const label = pref === 'system' ? 'Auto' : (isDark ? 'Dark' : 'Light');
  const detail = pref === 'system' ? `Auto (${effective})` : label;
  const next = isDark ? 'light' : 'dark';

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggle}
      title={`Theme: ${detail} — click for ${next} mode`}
      aria-label={`Theme: ${detail}. Click to switch to ${next} mode.`}
    >
      <Lighthouse lit={isDark} />
    </button>
  );
}
